const MIN_DISTANCE_PX = 10;

export const calculateHorizontalShift = (element: HTMLElement) => {
  const rect = element.getBoundingClientRect();
  const distanceFromRight = window.innerWidth - rect.right;
  const distanceFromLeft = rect.left + window.pageXOffset;

  if (distanceFromRight <= MIN_DISTANCE_PX) return distanceFromRight - MIN_DISTANCE_PX;
  if (distanceFromLeft <= MIN_DISTANCE_PX) return MIN_DISTANCE_PX - distanceFromLeft;

  return 0;
};
